module.exports = __webpack_public_path__ + "img/Tessellate10.4efa9a92.jpg";